module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.isDebugging) ? _c('div', {
    staticClass: "component",
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "left": "0",
      "background-color": "white",
      "z-index": "10000",
      "height": "35px",
      "width": "100%"
    }
  }, [_c('b', [_vm._v("Tid:\n  " + _vm._s(_vm.time) + "\n  " + _vm._s(_vm.seconds) + "\n")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6408e16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/WebFooter.vue
// module id = 1020
// module chunks = 0